export function isActiveDocument<T>(o?: any): o is T {
    return o?.active__document !== false;
}
